import qs from 'qs';
import { createActions } from 'redux-actions';
import { request } from '../../services';
import { getIqmsFilters, getIqmsPage } from '../../reducers';

const {
  iqmListRequest,
  iqmListSuccess,
  iqmListFailure,
} = createActions('IQM_LIST_SUCCESS', 'IQM_LIST_REQUEST', 'IQM_LIST_FAILURE');
export function requestIQMList() {
  return (dispatch, getState) => {
    const state = getState();
    const page = getIqmsPage(state);
    const filterParams = qs.stringify(getIqmsFilters(state));

    dispatch(iqmListRequest());
    return request(`iqms?page=${page}&${filterParams}`)
      .then(({ json }) => dispatch(iqmListSuccess(json, filterParams, page)))
      .catch(error => dispatch(iqmListFailure(error)));
  };
}

export function setIQMFilters(filter) {
  return (dispatch) => {
    dispatch({ type: 'IQM_SET_FILTER', payload: filter });
    dispatch({ type: 'IQM_RESET_PAGINATION' });
    return dispatch(requestIQMList());
  };
}

export function resetIQMFilters() {
  return dispatch => (
    Promise.all([
      dispatch({ type: 'IQM_RESET_FILTERS' }),
      dispatch({ type: 'IQM_RESET_PAGINATION' }),
      dispatch(requestIQMList()),
    ])
  );
}

const {
  iqmResourceRequest,
  iqmResourceSuccess,
  iqmResourceFailure,
} = createActions({
  IQM_RESOURCE_REQUEST: id => ({ id }),
  IQM_RESOURCE_SUCCESS: json => json.iqm,
}, 'IQM_RESOURCE_FAILURE');

export function requestIQM(id) {
  return (dispatch) => {
    dispatch(iqmResourceRequest(id));
    return request(`iqms/${id}`)
      .then(({ json }) => dispatch(iqmResourceSuccess(json)))
      .catch(error => dispatch(iqmResourceFailure(error)));
  };
}


const {
  iqmResourceCreateRequest,
  iqmResourceCreateSuccess,
  iqmResourceCreateFailure,
} = createActions({
  IQM_RESOURCE_CREATE_SUCCESS: json => json.iqm,
}, 'IQM_RESOURCE_CREATE_REQUEST', 'IQM_RESOURCE_CREATE_FAILURE');

export function createIQM(iqm) {
  return (dispatch) => {
    dispatch(iqmResourceCreateRequest());
    return request('iqms/', {
      method: 'POST',
      body: { iqm },
    })
      .then(({ json }) => dispatch(iqmResourceCreateSuccess(json)))
      .catch(error => dispatch(iqmResourceCreateFailure(error)));
  };
}

const {
  iqmResourceUpdateRequest,
  iqmResourceUpdateSuccess,
  iqmResourceUpdateFailure,
} = createActions({
  IQM_RESOURCE_UPDATE_SUCCESS: json => json.iqm,
}, 'IQM_RESOURCE_UPDATE_REQUEST', 'IQM_RESOURCE_UPDATE_FAILURE');

export function updateIQM(iqm) {
  return (dispatch) => {
    dispatch(iqmResourceUpdateRequest());
    return request(`iqms/${iqm.id}`, {
      method: 'PUT',
      body: { iqm },
    })
      .then(({ json }) => dispatch(iqmResourceUpdateSuccess(json)))
      .catch(error => dispatch(iqmResourceUpdateFailure(error)));
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/iqms.js